import { create } from "zustand";

const KEY = "shelf-sidebar-open";

function initialOpen(): boolean {
  try {
    return localStorage.getItem(KEY) !== "false";
  } catch {
    return true;
  }
}

function persist(v: boolean) {
  try {
    localStorage.setItem(KEY, String(v));
  } catch {
    // ignore unavailable storage
  }
}

interface UiState {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
  setSidebar: (open: boolean) => void;
}

export const useUiStore = create<UiState>((set, get) => ({
  sidebarOpen: initialOpen(),
  toggleSidebar: () => {
    const next = !get().sidebarOpen;
    persist(next);
    set({ sidebarOpen: next });
  },
  setSidebar: (open) => {
    persist(open);
    set({ sidebarOpen: open });
  },
}));
